import { Alert } from "~/common/m3/Alert/Alert";
import { type MessageProps } from "./Message";
import { useTranslation } from "react-i18next";

interface Props extends Omit<MessageProps, "children" | "message" | "type"> {}

const NotFinal = (props: Props) => (
  <Alert severity={"info"} {...props}>
    {useTranslation().t("housing.message.finalImage")}
  </Alert>
);

const EditQuantity = (props: Props) => (
  <Alert severity={"info"} {...props}>
    {useTranslation().t("housing.message.editQuantity")}
  </Alert>
);

const HSAUnits = (props: Props) => (
  <Alert severity={"info"} {...props}>
    {useTranslation().t("housing.message.hsaUnits")}
  </Alert>
);

const PackagingDisclaimer = (props: Props) => (
  <Alert severity={"info"} {...props}>
    {useTranslation().t("housing.message.packaging")}
  </Alert>
);

export const HousingMessages = {
  NotFinal,
  EditQuantity,
  HSAUnits,
  PackagingDisclaimer,
};
